const FavoritesIcon = () => (
  <svg fill="none" height="79" viewBox="0 0 81 79" width="81" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M40.5 66.4759L19.1611 77.7246C16.6522 79.0472 13.7252 76.9015 14.2058 74.0921L18.2777 50.2871L1.04094 33.4402C-0.994849 31.4505 0.1245 27.9745 2.93281 27.5654L26.7659 24.0929L37.4366 2.41357C38.6924 -0.137857 42.3076 -0.137855 43.5634 2.41357L54.2341 24.0929L78.0672 27.5654C80.8755 27.9745 81.9948 31.4505 79.9591 33.4402L62.7223 50.2871L66.7942 74.0921C67.2748 76.9015 64.3478 79.0472 61.8389 77.7246L40.5 66.4759Z"
      fill="#B8B8B8"
      fillRule="evenodd"
    />
  </svg>
);

export { FavoritesIcon };
